<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Affiliate Users</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" /></div>
                    <div class="col-sm-3">
                        <mat-select placeholder="Status" [(ngModel)]="status">
                            <mat-option>All</mat-option>
                            <mat-option value="1">Active</mat-option>
                            <mat-option value="0">In-Active</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadUsersList(0,perpage)"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                    class="fa fa-sync"></i> Reset Filters</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadUsersList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button></div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>EMAIL</th>
                            <th>Contact Number</th>
                            <th>Affiliate Id</th>
                            <th>Type</th>
                            <th>Created By</th>
                            <th>Created By Email</th>
                            <th>Add Description</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th>Margin Percentage</th>
                            <th *ngIf="myrole=='1' || mark_as_affiliate=='1'">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of usersList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{user.name}}</td>
                            <td>{{user.email}}</td>
                            <td>{{user.mobile}}</td>
                            <td>{{user.affiliate_id}}</td>
                            <td>
                                <span class="badge bg-azure-light" *ngIf="user.affiliate_type==1">Ambulance</span>
                                <span class="badge bg-azure-light" *ngIf="user.affiliate_type==2">Optical Clinics</span>
                                <span class="badge bg-azure-light" *ngIf="user.affiliate_type==3">Doctors</span>
                                <span class="badge bg-azure-light" *ngIf="user.affiliate_type==4">Insurance Agent</span>
                                <span class="badge bg-azure-light" *ngIf="user.affiliate_type==5">Compititors</span>
                                <span class="badge bg-azure-light" *ngIf="user.affiliate_type==6">Others</span>
                            </td>
                            <td>{{user.created_by_name}}</td>
                            <td>{{user.created_by_email}}</td>
                            <td>
                                <span class="badge bg-green-light" (click)="showUserDescriptionModal(user.id,user.description)" style="cursor: pointer;">Add Description</span></td>
                            <td  ng-init="limit = 20">{{user.description | slice:0:80 }}...</td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="user.status==1">Active</span>
                                <span class="badge bg-azure-light" *ngIf="user.status==0">In-Active</span>
                            </td>
                            <td>{{user.margin_percentage}}</td>
                            <td *ngIf="myrole=='1' || mark_as_affiliate=='1'">
                                <div class="dropdown">
                                   <button class="btn btn-secondary dropdown-toggle" type="button" id="{{user.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                       Action
                                   </button>
                                   <div class="dropdown-menu" aria-labelledby="{{user.id}}">
                                       <a class="dropdown-item" routerLink="/update-affiliate-user/{{user.id}}"><i class="fa fa-pen"></i> Update</a>
                                       <a *ngIf="myrole=='1'" class="dropdown-item" (click)="openUserHistoryPopup(user.id)"><i class="fa fa-eye"></i> History
                                       </a>
                                   </div>
                                </div>
                           </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !usersList.length">
                            <td colspan="20"><i class="far fa-frown"></i> Users not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>

 <!-- The Modal For Update MD spok Description -->
 <div class="modal fade" id="myUserModelDescription">
    <form [formGroup]="descriptionForm" (submit)="saveUserDescription()">
        <!-- <form> -->
        <div class="modal-dialog">
        <div class="modal-content">
    
            <!-- Modal Header -->
            <div class="modal-header">
            <h4 class="modal-title">Add Description </h4>
            <button type="button" class="close" (click)="hideUserDescriptionModal()"></button>
            </div>
    
            <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <div class="col-sm-11" style="margin:auto ;">
                            <!-- <label for="exampleFormControlTextarea1">Enter Description</label> -->
                            <textarea class="form-control" formControlName="description" rows="3"></textarea>
                            <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                <div *ngIf="f.description.errors.required">Description is required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- Modal footer -->
            <div class="modal-footer">
                <button  type="submit" [disabled]="descriptionAddLoading" class="btn btn-primary" ><i *ngIf="descriptionAddLoading" class="fa fa-spin fa-spinner"></i> 
                    <span>Submit</span>    
                </button>
            <button type="button" class="btn" (click)="hideUserDescriptionModal()">Close</button>
            </div>
        </div>
        </div>
    </form>
</div>


<!-- The Modal to view Product history -->
<div class="modal fade" id="myHistoryModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Update User History</h4>
            <button type="button" class="close" (click)="closeHistoryPopup()"></button>
        </div>
        <div class="modal-body history_modal">
            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
              <tbody>
                  <tr *ngFor="let updatedLog of updatedLodData">
                      <td class="no-padding-bottom">
                          <div class="small_text" [innerHTML]="updatedLog.message | safe:'html'"></div>
                          <div class="small text-muted small_text_creation">
                              <i class="fas fa-clock"></i> {{updatedLog.created_at*1000|date:'dMMM, yyyy h:mm aa'}}
                          </div>
                      </td>
                  </tr>
                  <tr *ngIf="!updatedLodData.length && history_loaded">
                      <td>No history found</td>
                  </tr>
                  <tr *ngIf="history_loading">
                      <td><i class="fa fa-spin fa-spinner"></i></td>
                  </tr>
              </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" (click)="closeHistoryPopup()">Close</button>
        </div>
      </div>
    </div>
  </div>